module.exports = __webpack_public_path__ + "img/8-en.0a0368ce.png";